import qs from 'qs'
import SuperagentApi from '../assets/utils/superagent'

const token = Wiz.AuthHooks.GetToken()
const headers = {
  Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
}
const superagentApi = new SuperagentApi({
  baseUrl: window.ApiBase || 'http://pr.code.wiz.top:1052',
})
export default class DiyService {
  // 获取模块对应文件信息
  static async getTableData(payload) {
    const [err, res] = await superagentApi.post('/api/FormEngine/getTableData', {
      data: payload,
      headers,
    })
    return [err, res]
  }
}
